module.exports = __webpack_public_path__ + "img/error.ae6b019f.svg";